"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ValidationMessage: true
};
exports.default = exports.ValidationMessage = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _ValidationMessage = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ValidationMessage.css") : void 0);
var _ValidationMessage2 = require("./_ValidationMessage.types");
Object.keys(_ValidationMessage2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ValidationMessage2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ValidationMessage2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-validation-message';
const ValidationMessage = props => {
  const {
      className,
      inPopper,
      state = 'error',
      text
    } = props,
    otherProps = __rest(props, ["className", "inPopper", "state", "text"]);
  const classnames = _bind.default.bind(_ValidationMessage.default);
  const classes = classnames(CSS_BLOCK, `${CSS_BLOCK}--${state}`, {
    [`${CSS_BLOCK}--popper`]: inPopper
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classes
  }), text);
};
exports.ValidationMessage = ValidationMessage;
ValidationMessage.displayName = 'ValidationMessage';
var _default = exports.default = ValidationMessage;